/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_CollectionsInputs */

const en_page_title_collections = /** @type {(inputs: Page_Title_CollectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const nl_page_title_collections = /** @type {(inputs: Page_Title_CollectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collecties`)
};

/**
* | output |
* | --- |
* | "Collections" |
*
* @param {Page_Title_CollectionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_collections = /** @type {((inputs?: Page_Title_CollectionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_CollectionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_collections(inputs)
	return en_page_title_collections(inputs)
});